<div class="fixed top-4 right-4 z-50 flex flex-col gap-2">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast-item flex items-center gap-3 bg-ledger-panel border border-ledger-rule rounded-lg shadow-lg px-4 py-3 min-w-72 max-w-sm">
      <ng-icon name="lucideCircleCheck" class="text-ledger-green shrink-0" [size]="'20'"></ng-icon>
      <p class="text-sm text-ledger-ink flex-1">{{ toast.message }}</p>
      <button
        type="button"
        class="text-ledger-muted hover:text-ledger-ink transition-colors"
        (click)="dismiss(toast.id)"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  }
</div>
